import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { V2Card } from '@uhg-abyss/web/ui/Card';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { SubmitterInformationCard } from './ReviewCards/SubmitterInformationCard';
import { W9InformationCard } from './ReviewCards/W9InformationCard';
import { PracticeInformationCard } from './ReviewCards/PracticeInformationCard';
import { LocationInformationCard } from './ReviewCards/LocationInformationCard';

const SectionStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const PageHeading = styled('p', {
  fontSize: '30px',
  fontWeight: 700,
  color: '$primary1',
});

const PageSubtext = styled('p', {
  fontSize: '16px',
  fontWeight: 500,
  margin: '-52px 0 0 0',
});

const PrintLink = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  color: '$info1',
  fontSize: '16px',
  fontWeight: 700,
});

const SectionHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '24px',
});

export const Review = ({ onEdit, isPrinting, onPrintClick }) => {
  return (
    <V2Card>
      <SectionStack>
        <SectionHeader>
          <PageHeading>Review your information</PageHeading>
          {!isPrinting && (
            <PrintLink onClick={onPrintClick}>
              <IconSymbol icon="print" variant="outlined" size="16px" />
              Print/Save as PDF
            </PrintLink>
          )}
        </SectionHeader>

        <PageSubtext>
          Please review all the information below carefully before attestation.
          {!isPrinting &&
            ' You can edit any section by clicking the "Edit" button.'}
        </PageSubtext>

        <SubmitterInformationCard onEdit={onEdit} isPrinting={isPrinting} />

        <W9InformationCard onEdit={onEdit} isPrinting={isPrinting} />

        <PracticeInformationCard onEdit={onEdit} isPrinting={isPrinting} />

        <LocationInformationCard onEdit={onEdit} isPrinting={isPrinting} />
      </SectionStack>
    </V2Card>
  );
};
